export const Requests = {
    HttpRequest: 'Trace: RequestToApi',
    HttpResponse: 'Trace: ResponseFromApi'
}